import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {FocusMonitor} from '@angular/cdk/a11y';
import {BaseField} from './base-field';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Directive,
    ElementRef,
    HostBinding,
    Input, NgZone,
    OnDestroy,
    OnInit
} from '@angular/core';
import {Subject, Subscription} from 'rxjs';

@Directive()
export abstract class BaseFieldDirective implements OnInit, OnDestroy {
    
    static nextId = 0;
    subscriptions: Subscription[] = [];
    @HostBinding() id = `input-${BaseFieldDirective.nextId++}`;
    focused = false;
    @Input() config!: BaseField;
    @Input() item: any = {};
    @Input() formGroup!: UntypedFormGroup;
    private cssOriginal: string = '';
    private valorDisable: boolean = false;
    private valorEsconder: boolean = false;
    
    protected constructor(
        protected fm: FocusMonitor,
        protected el: ElementRef<HTMLElement>,
        protected changeDetector: ChangeDetectorRef,
        protected ngZone: NgZone
    ) {
        this.subscriptions.push(fm.monitor(el, true).subscribe(origin => {
            this.focused = !!origin;
            this.stateChanged.next();
            (this.formGroup!.get(this.config!.property) as UntypedFormControl).updateValueAndValidity();
        }));
    }
    
    public get controle(): UntypedFormControl {
        return this.formGroup!.get(this.config!.property) as UntypedFormControl;
    }
    
    public get requerido(): boolean {
        return !!this.config?.validations?.find(x => x.name === 'required');
    }
    
    stateChanged = new Subject<void>();
    
    ngOnInit(): void {
        this.config!.id = this.id;
        this.cssOriginal = this.config!.css;
        
        this.processarDisable();
        // this.processarEsconder();
        
        this.subscriptions.push(
            this.formGroup.valueChanges.subscribe((value: any) => {
                this.processarDisable();
                // this.processarEsconder();
            })
        );
    }
    
    processarDisable(): void {
        let retornoDisable = this.config!.disabled instanceof Function ? this.config!.disabled(this.item) : this.config!.disabled;
        if(retornoDisable !== this.valorDisable){
            this.valorDisable = retornoDisable;
            
            if (this.valorDisable) {
                this.controle.disable();
            }else{
                this.controle.enable();
            }
        }
    }
    
    processarEsconder(): void {
        let retornoEsconder = this.config!.esconder instanceof Function ? this.config!.esconder(this.item) : this.config!.esconder;
        if(retornoEsconder !== this.valorEsconder){
            this.valorEsconder = retornoEsconder;
            
            if (this.valorEsconder) {
                this.config!.css = 'd-none';
            }else{
                this.config!.css = this.cssOriginal;
            }
        }
    }
    
    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe());
    }
}
